import { Preferences } from "@capacitor/preferences";

let _memoryPrefs = {};

const preferences = {
	load: async () => {
		const { keys } = await Preferences.keys();
		const prefs = await Promise.all(
			keys.map(async (key) => {
				const { value } = await Preferences.get({ key });
				_memoryPrefs[key] = value;
				return value;
			})
		);
	},

	getKey: (key) => {
		if (_memoryPrefs[key]) {
			return _memoryPrefs[key];
		} else {
			return "null";
		}
	},

	setKey: async (key, value) => {
		_memoryPrefs[key] = value;
		return Preferences.set({ key, value });
	},

	clear: async (key) => {
		delete _memoryPrefs[key];
		return await Preferences.remove({ key });
	},
};

export default preferences;
